import type {ReactElement} from 'react';
import React from 'react';
import type {ColorFillStorage} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ContextualMenuColorFillOption} from '@Components/contextual-menu/components/contextual-menu-color-fill-option';
import {ColorFillPropertyType} from '@Components/color-fill';
import {getColorObjectArrayFromFillColor} from '@Utils/color.util';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromTableItem} from '@Hooks/poster-editor/useGetKeyFromTableItem';

interface ScheduleHighlightedBackgroundOptionProps {
  onClickColorFill(): void;
  label?: string;
}

export function LayoutHighlightedBackgroundOption({label = window.i18next.t('pmwjs_background_color'), ...props}: ScheduleHighlightedBackgroundOptionProps): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const highlightedBgColor = useGetKeyFromTableItem('highlightedBackgroundColor');

  if (!activeItem || (activeItem && !('highlightedBackgroundColor' in activeItem)) || !highlightedBgColor) {
    throw new Error('Item does not have highlightedBackgroundColor property');
  }

  const onClickHandler = (): void => {
    props.onClickColorFill();
  };

  const getData = (): ColorFillStorage[] => {
    return [{id: 'schedule-highlighted-background-color', fillType: ColorFillPropertyType.SOLID, color: getColorObjectArrayFromFillColor([highlightedBgColor])}];
  };

  return <ContextualMenuColorFillOption id="highlighted-background-color-option" label={label} data={getData()} onClick={onClickHandler} />;
}
